// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils__DictPlus from "@pageblocks/utils/src/dictPlus/Utils__DictPlus.bs.js";
import * as Utils__AllOptionalParser from "@pageblocks/utils/src/Utils__AllOptionalParser.bs.js";

function updateBoxChildPropsToApplyOpacityOnHighlight(props, interactionState, opacity) {
  var settings = Core__Option.getOr(Utils__AllOptionalParser.object(Utils__AllOptionalParser.obj(props), "settings"), {});
  return Object.fromEntries([[
                "settings",
                Utils__DictPlus.addEntries(settings, interactionState.pressed ? [[
                          "opacity",
                          opacity
                        ]] : [])
              ]]);
}

function getActions(triggerActions) {
  return Utils__AllOptionalParser.array(Utils__AllOptionalParser.obj(triggerActions), "actions");
}

export {
  updateBoxChildPropsToApplyOpacityOnHighlight ,
  getActions ,
}
/* No side effect */
